import React from 'react';
import PropTypes from 'prop-types';

import DsLabel from '../label';
import Btn from './index';

const BtnClose = ({ label, className, onClick }) => (
    <Btn onClick={onClick} className={`${className || ''} flex justify-center items-center`}>
        <DsLabel icon="cross" className="text-primary capitalize">
          {label}
        </DsLabel>
    </Btn>
);

BtnClose.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default BtnClose;
